import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { foreignContactFrequencyOptions, foreignGovernmentServiceOptions } from 'constants/enums/foreignActivityOptions';
import { EmploymentForeignServiceContact, EmploymentForeignServiceItemModel } from '../types';

// Foreign Employment is all PVQ Only
const pvqForeignEmploymentItemValidator: ValidateJSModel<EmploymentForeignServiceItemModel> = {
  Discipline: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: foreignGovernmentServiceOptions,
      },
    },
  }),

  DisciplineOtherExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.Discipline?.value === 'Other') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  Country: { hasValue: true, country: true },

  Agency: { presence: true, hasValue: true },

  CivilianOrMilitary: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: ['Civilian', 'Military member'],
      },
    },
  }),

  HighestRank: { presence: true, hasValue: true },

  Department: { presence: true, hasValue: true },

  HowAssociated: { presence: true, hasValue: true },

  DatesServed: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  ReasonLeft: (value, attributes, attributeName, options) => {
    if (attributes?.DatesServed?.present === true) {
      return { };
    }

    return { presence: true, hasValue: true };
  },

  ForeignContacts: (value, attributes, attributeName, options) => ({
    presence: true,
    branchCollection: {
      validator: PvqEmploymentForeignContactItemValidator,
    },
  }),
};

const PvqEmploymentForeignContactItemValidator: ValidateJSModel<EmploymentForeignServiceContact> = {
  Name: {
    presence: true,
    model: {
      validator: pvqNameModelValidator,
      requireMiddleName: false
    },
  },

  Rank: { presence: true, hasValue: true },

  DateMet: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;
    return {
      presence: true,
      date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },

  DateLastContacted: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;
    return {
      presence: true,
      date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },

  Frequency: {
    hasValue: {
      validator: {
        inclusion: foreignContactFrequencyOptions,
      },
    },
  },

  FrequencyOtherExplanation: (value, attributes) => {
    if (attributes?.Frequency?.value === 'Other') {
      return { hasValue: true };
    }

    return {};
  },

  InUsaNotApplicable: {},

  Address: (value, attributes) => {
    if (attributes?.InUsaNotApplicable?.applicable !== false) {
      return {
        presence: true,
        location: {
          validator: pvqLocationModelValidator,
          requireStreet: true,
        },
      };
    }

    return {};
  },

  Relationship: { presence: true, hasValue: true },
};

export default pvqForeignEmploymentItemValidator;
